/**
 * FASE A — STAP 0 prototype: maand/ISO-module (pure functies, geen UI/app-imports).
 *
 * Regel B: een maand bestaat uit alle ISO-weken waarvan de MAANDAG in die maand valt.
 * Alle datums lokaal (zelfde semantiek als afwezigheid.js); dag-diffs via Math.round
 * zodat DST-overgangen (23/25-uurs dagen) geen off-by-one geven.
 */

const DAG_MS = 24 * 60 * 60 * 1000;

/** ISO-8601 weeknummer + ISO-jaar voor een datum. */
export function isoWeekNummer(datum) {
  // normaliseer naar middernacht lokaal en verschuif naar de DONDERDAG van deze week:
  // de donderdag bepaalt bij welk ISO-jaar de week hoort.
  const d = new Date(datum.getFullYear(), datum.getMonth(), datum.getDate());
  const dag = d.getDay() || 7; // 1=ma .. 7=zo
  d.setDate(d.getDate() + 4 - dag);
  const isoJaar = d.getFullYear();
  const jan1 = new Date(isoJaar, 0, 1);
  const diffDagen = Math.round((d - jan1) / DAG_MS);
  return { week: Math.floor(diffDagen / 7) + 1, isoJaar };
}

/** Maandag van een ISO-week — zelfde semantiek als afwezigheid.js (Jan 4 is altijd week 1). */
export function weekNaarMaandag(weeknummer, isoJaar) {
  const jan4 = new Date(isoJaar, 0, 4);
  const dag = jan4.getDay() || 7;
  const week1Ma = new Date(jan4);
  week1Ma.setDate(jan4.getDate() - dag + 1);
  const result = new Date(week1Ma);
  result.setDate(week1Ma.getDate() + (weeknummer - 1) * 7);
  return result;
}

/**
 * Regel B: alle ISO-weken van (jaar, maand 1-12).
 * -> { weken: [{ week, isoJaar, maandag: 'YYYY-MM-DD' }], aantal }
 */
export function maandWeken(jaar, maand) {
  // eerste maandag op of na de 1e van de maand
  const eerste = new Date(jaar, maand - 1, 1);
  const offset = (8 - (eerste.getDay() || 7)) % 7; // 0 als de 1e zelf maandag is
  const maandag = new Date(jaar, maand - 1, 1 + offset);

  const weken = [];
  while (maandag.getMonth() === maand - 1) {
    const { week, isoJaar } = isoWeekNummer(maandag);
    weken.push({ week, isoJaar, maandag: datumStr(maandag) });
    maandag.setDate(maandag.getDate() + 7);
  }
  return { weken, aantal: weken.length };
}

export function datumStr(d) {
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
